import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const leagueDetailDefaultLayout: LayoutRuntime = {
  feature: "league-detail",
  layout: "default",
  rootClass: "gwd-livescore-layout--default",
};
